import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'
import { dateFormat } from '@/Utils/fliter'

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, data, vm, titleData) => {
    try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = []
      pdfContent.push(
        {
          table: {
            style: 'tableData',
            headerRows: 0,
            widths: ['25%', '50%', '25%'],
            body: [
              [
                { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
                { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                { image: reportHeadData.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
              ],
              [
                {},
                { text: vm.$t('social_service.dss'), style: 'header2', alignment: 'center' },
                {}
              ],
              [
                {},
                {},
                {}
              ],
              [
                {},
                { text: reportHeadData.address, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportTitle, style: 'address2', alignment: 'center' },
                {}
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        }
      )

      //
      pdfContent.push(
        {
          table: {
            style: 'tableData',
            headerRows: 0,
            widths: ['50%', '50%'],
            body: [
              [
                { text: vm.$t('report_monthly.worlplace_name') + ' : ' + (titleData.workplace_name ? titleData.workplace_name : ''), style: 'th', alignment: 'left' },
                {}
              ],
              [
                { text: vm.$t('report.month_name') + ' : ' + titleData.month_name, style: 'th', alignment: 'left' },
                {}
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        }
      )

      // Empty Space
      pdfContent.push(
        { text: '', style: 'empty_space' }
      )
      // List Data
      const allRowsHead = [
              [
                { text: vm.$t('report.sl_no_tarikh'), style: 'th', alignment: 'center' },
                { text: vm.$t('report.goods_name'), style: 'th', alignment: 'center' },
                { text: vm.$t('report.previous_stock'), style: 'th', alignment: 'center' },
                { text: vm.$t('report.new_receipt'), style: 'th', alignment: 'center' },
                { text: vm.$t('report.total_amount'), style: 'th', alignment: 'center' },
                { text: vm.$t('report.distribution'), style: 'th', alignment: 'center' },
                { text: vm.$t('report.rest'), style: 'th', alignment: 'center' }
              ],
              // 3
              [
                { text: vm.$n(1), style: 'th', alignment: 'center' },
                { text: vm.$n(2), style: 'th', alignment: 'center' },
                { text: vm.$n(3), style: 'th', alignment: 'center' },
                { text: vm.$n(4), style: 'th', alignment: 'center' },
                { text: vm.$n(5), style: 'th', alignment: 'center' },
                { text: vm.$n(6), style: 'th', alignment: 'center' },
                { text: vm.$n(7), style: 'th', alignment: 'center' }
              ]
            ]
      pdfContent.push({
        table: {
          headerRows: 0,
          widths: ['10%', '*', '*', '*', '*', '*', '*'],
          body: allRowsHead
        }
      })
        const allRowsHead2 = []
        Object.entries(data).forEach(([index, item], e) => {
          const indexText = vm.isIndexInRange(index, vm.firstday(), vm.lastday()) ? dateFormat(index) : ''
          const textFields = [
            vm.hosItemList.map(itemx => (vm.sum(item, itemx.value) > 0) ? vm.getItemName(itemx.value) : '').filter(itemName => itemName !== '').join('\n\n'),
            vm.hosItemList.map(itemx => (vm.sum(item, itemx.value) > 0) ? vm.$n(vm.prevSum(index, itemx.value)) : '').filter(itemName => itemName !== '').join('\n\n'),
            vm.hosItemList.map(itemx => (vm.sum(item, itemx.value) > 0) ? vm.$n(vm.sum(item.filter(item => item.donation_in_type === 1), itemx.value)) : '').filter(itemName => itemName !== '').join('\n\n'),
            vm.hosItemList.map(itemx => (vm.sum(item, itemx.value) > 0) ? vm.$n(vm.prevSum(index, itemx.value) + vm.sum(item.filter(item => item.donation_in_type === 1), itemx.value)) : '').filter(itemName => itemName !== '').join('\n\n'),
            vm.hosItemList.map(itemx => (vm.sum(item, itemx.value) > 0) ? vm.$n(vm.sum(item.filter(item => item.donation_out_type === 1), itemx.value)) : '').filter(itemName => itemName !== '').join('\n\n'),
            vm.hosItemList.map(itemx => (vm.sum(item, itemx.value) > 0) ? vm.$n(vm.prevSum(index, itemx.value) + vm.sum(item.filter(item => item.donation_in_type === 1), itemx.value) - vm.sum(item.filter(item => item.donation_out_type === 1), itemx.value)) : '').filter(itemName => itemName !== '').join('\n\n')
          ]
          if (indexText !== '') {
            allRowsHead2.push([
              { text: indexText, style: 'th', alignment: 'center' },
              ...textFields.map(text => ({ text, style: 'th', alignment: 'center' }))
            ])
          }
        })
      pdfContent.push({
        table: {
          headerRows: 1,
          widths: ['10%', '*', '*', '*', '*', '*', '*'],
          body: allRowsHead2
        }
      })
      var docDefinition = {
      content: pdfContent,
      pageSize: 'A4',
      pageOrientation: 'landscape',
      styles: {
          th: {
            fontSize: 10,
            margin: [3, 3, 3, 3]
          },
          th1: {
              fontSize: 9
            },
          td: {
            fontSize: 8,
            margin: [3, 3, 3, 3]
          },
          header: {
            margin: [0, 1, 0, 15],
            fontSize: 16,
            alignment: 'center'
          },
          header2: {
            border: 0,
            fontSize: 14,
            margin: [0, 0, 0, 1]
          },
          govt_info: {
            margin: [0, 1, 0, 1],
            fontSize: 18,
            alignment: 'center'
          },
          address2: {
            border: 0,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 5]
          },
          left_logo: {
            borderRadius: 50
          },
          empty_space: {
            margin: [10, 10, 10, 10]
          }
        }
      }
      // pdfMake.createPdf(docDefinition, null, null, null).print() // 'financial-aid-report')
      pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {
      }
    }

    // Loading Complete
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}

export default {
  exportPdfDetails
}
